<div class="comment-skeleton">
  <opac-skeleton class="avatar-skeleton"></opac-skeleton>

  <div class="content">
    <div class="header">
      <opac-skeleton class="header-skeleton"></opac-skeleton>
    </div>

    <opac-skeleton class="content-skeleton"></opac-skeleton>
    <opac-skeleton class="content-skeleton"></opac-skeleton>
    <opac-skeleton class="content-skeleton"></opac-skeleton>

    <div class="footer">
      <div>
        <opac-skeleton class="vote-button-skeleton"></opac-skeleton>
        <opac-skeleton class="vote-text-skeleton"></opac-skeleton>
      </div>

      <div>
        <opac-skeleton class="vote-button-skeleton"></opac-skeleton>
        <opac-skeleton class="vote-text-skeleton"></opac-skeleton>
      </div>
    </div>
  </div>
</div>
